import { RouteRecordRaw } from "vue-router";

import Employees from "./pages/Employees.vue";
import EmployeeDetail from "./pages/EmployeeDetail.vue";

const routes: RouteRecordRaw[] = [
    {
        path: "/employee",
        component: Employees,
        meta: {
            requiresAuth: true,
            menu: {
                order: 3,
                label: "Dipendenti",
                iconAsset: "icons/ico-dipendenti.svg"
            }
        }
    },
    {
        path: "/employee/detail/:id/:activeTab?",
        component: EmployeeDetail,
        meta: {
            requiresAuth: true,
            menu: {
                label: "Dipendenti",
                iconAsset: "icons/ico-dipendenti.svg",
                hidden: true
            }
        }
    }
];

export default routes;
